export default {
  p1: [
    'Are you looking for professional medical writing services to prepare all the necessary documents required during your drug development and clinical trial processes? If so, you have come to the right place.',
    'STATECS’ medical writers will cover all your clinical documentation needs and requirements in accordance with the highest standards. We provide well-written, accurate, science-based, and cost-effective medical writing services: from regulatory documents to research reports - we do it all.',
    'Our clinical trial documents will precisely and clearly describe medical research data, product use, and other relevant scientific and health-related information.',
  ],
  p2: [
    'Our medical writing services include but are not limited to:',
    '●\tProtocol development (synopses and amendments included)',
    '●\tInformed consent forms',
    '●\tClinical study reports',
    '●\tDevelopment safety update reports',
    '●\tSOPs',
    '●\tInvestigator brochures',
    '●\tIndependent review charter',
    '●\tPatient material',
    '●\tInvestigator meeting material',
    '●\tRegulatory authority responses',
    '●\tMultiple types of support documented needed for product launch',
    '●\tManuscripts and study reports',
    '●\tSlide kits, claim substantiation, and dossiers for ongoing market support',
  ],
  p3: [
    'Medical writing requires special skills and expertise in drug development and pharmaceutics in order to be relevant and of actual use for clinical research.',
    'Our writers are experienced and highly knowledgeable in clinical data collection and analysis which is why they always deliver professionally written documents that meet all the standards of research and pharmaceutical organizations.',
    'To deliver the best medical documents and reports to our clients, we are guided by the following principles:',
  ],
  p4: [
    {
      title: 'Science-Based',
      context: 'At STATECS we understand that there cannot be a different way in medical writing other than having scientifically proven data as the foundation of all the documents created. The material of our papers is scientifically robust and there cannot be any exception to this.',
    },
    {
      title: 'Accurate',
      context: 'Our medical writers know the importance of documents they are writing for drug development and clinical trials. Providing highly accurate and precise information is their number one priority.',
    },
    {
      title: 'Responsive',
      context: 'Should you have any questions or change requirements, STATECS medical writers are there to help you. Don’t hesitate to communicate your needs and expectations clearly for a mutually beneficial collaboration.',
    },
  ],
  p5: ['We care about our customers and we give big importance to building relationships based on trust and reliability. All documents created by STATECS are edited and thoroughly reviewed from all the relevant aspects: scientific, statistical, and quality.'],
};
